export default __webpack_public_path__ + "static/media/xIcon.6d0eb6ea.jpg";